import { localStorageBackedLoad } from "../../../../utils/cached-data-load";

const titanApiService = () => {
  const getImageSizes = async (imageId) => {
    try {
      const url = `api/titan/${imageId}`;//`https://titanapi.churchofjesuschrist.org/assetsearch/api/v2/asset/details/versionID/${imageId}`
      const key = `titan-${imageId}`;
      const expiration = {days:14};

      const data = await localStorageBackedLoad({url,key,expiration, crossDomain:true});

      return data?.result?.renditions ?? [];

    } catch {
      return [];
    }
  }
  return {
    getImageSizes
  };
}

export default titanApiService;